import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import UserManagerPage from "./UserManagerPage";
import {IonButton, IonCheckbox, IonInput, IonItem, IonLabel, IonLoading, IonToggle, useIonAlert} from "@ionic/react";
import {useMutation, useQuery} from "@apollo/client";
import {USER_GET_RULES_QUERY, USER_MANAGER_CREATE_ROLE} from "../../schemas/userManager";

const UserManagerCreateRole: React.FC<any> = () => {

    const history = useHistory();
    const [alert, dismissAlert] = useIonAlert();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const {loading:rulesLoading, error:rulesError, data: rulesData} = useQuery(USER_GET_RULES_QUERY, {variables: {}});
    const [createRoleMutation] = useMutation(USER_MANAGER_CREATE_ROLE);


    const [name, setName] = useState<string | null | undefined>(undefined);
    const [details, setDetails] = useState<string | null |  undefined>(undefined);
    const [color, setColor] = useState<string | undefined | number | readonly string[]>(undefined);
    const [rulesList, setRulesList] = useState<number[]>([]);

    const createRole = async () => {
        // validate name, details, and at least one rule
        setIsLoading(true);
        let validationErrors: string[] = [];
        if (!name || name.length < 2) {
            validationErrors.push("Please enter a name");
        }
        if (!color || color.toString().length !== 7) {
            validationErrors.push("Please enter a valid color");
        }
        if (!details || details.length < 2) {
            validationErrors.push("Please enter details");
        }
        if (rulesList.length === 0) {
            validationErrors.push("Please select at least 1 rule");
        }
        if (validationErrors.length > 0) {
            setIsLoading(false);
            await alert("Errors: <ul><li>" + validationErrors.join("</li><li>") + '</li></ul>');
            return;
        }

        // submit
        const createResult = await createRoleMutation({variables: {data: {name, details, color, rules:rulesList}}});
        setIsLoading(false);
        if (createResult.data.userManagerCreateRole.success) {
            await alert("Successfully created role");
            setRulesList([]);
            setName(undefined);
            setDetails(undefined);
            setColor(undefined);
        } else {
            await alert("Error: " + createResult.data.userManagerCreateRole.error);
        }
    };

    const updateRules = async (checked: boolean, ruleId: number)=> {

        let tmpList = rulesList;
        if (checked) {
            // adding to list
            tmpList.push(ruleId);
        } else {
            // removing from list
            tmpList = tmpList.filter(n => n !== ruleId);
        }
        setRulesList(tmpList);
    }

    return (
        <UserManagerPage page={'create-role'}>

            <IonLoading isOpen={isLoading}/>

            <div className="userManagerContent">
                <div style={{backgroundColor: '#ffffff', padding: '10px', margin: '0px'}}>

                    <h1 style={{backgroundColor: '#ffffff', padding: '0px', margin: '0px'}}>Create Role</h1>


                    <div style={{display: "table", borderCollapse: "separate", borderSpacing: "10px"}}>
                        <div style={{display: "table-row"}}>
                            <div style={{display: "table-cell"}}>
                                <b>Name:</b>
                            </div>
                            <div style={{display: "table-cell"}}>
                                <IonItem>
                                    <IonInput value={name} onIonChange={(e) => setName(e.detail.value)}></IonInput>
                                </IonItem>
                            </div>
                            <div style={{display: "table-cell"}}>

                            </div>
                        </div>
                        <div style={{display: "table-row"}}>
                            <div style={{display: "table-cell"}}>
                                <b>Color:</b>
                            </div>
                            <div style={{display: "table-cell"}}>
                                <IonItem>
                                    <input type="color" value={color} onChange={(e) => setColor(e.currentTarget.value)}></input>
                                </IonItem>
                            </div>
                            <div style={{display: "table-cell"}}>
                                <div style={{
                                    width: '10px',
                                    height: '10px',
                                    backgroundColor: color?.toString(),
                                    border: '1px solid black'
                                }}></div>
                            </div>
                        </div>
                        <div style={{display: "table-row"}}>
                            <div style={{display: "table-cell"}}>
                                <b>Details:</b>
                            </div>
                            <div style={{display: "table-cell"}}>
                                <IonItem>
                                    <IonInput value={details} onIonChange={(e) => setDetails(e.detail.value)}></IonInput>
                                </IonItem>
                            </div>
                            <div style={{display: "table-cell"}}>

                            </div>
                        </div>
                    </div>

                    <p>Select the rules you would like to add to this new role:</p>
                    {rulesData && rulesData.getRules && rulesData.getRules.map((rule: any) => {
                        return (
                            <div className="checkbox-button" key={"role_selection_" + rule.id}>
                                <div className="checkbox-button-inner">
                                    <IonCheckbox id={'check_' + rule.id} value={rule.id} onIonChange={(e) => updateRules(e.detail.checked, e.detail.value)} checked={rulesList.includes(rule.id)}></IonCheckbox>&nbsp;
                                    <IonLabel onClick={(e) => document.getElementById('check_' + rule.id)?.click()}>{rule.name}</IonLabel>

                                </div>
                            </div>
                        )
                    })}
                    <div style={{clear: "both"}}></div>

                    <p style={{textAlign: 'right'}}>
                        <IonButton fill="outline" onClick={() => history.goBack()}>Go Back</IonButton>
                        <IonButton onClick={() => createRole()}>Create Role</IonButton>
                    </p>
                </div>
            </div>
        </UserManagerPage>
    );
};


export default UserManagerCreateRole;